
import {throwError as observableThrowError,  Observable, catchError } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Keyword, Keywords } from '@docma-core/keyword/keyword';

import { ConfigService } from '@docma-mm-core/config/config.service';
import {joinUrl} from '@docma-mm-core/utils/utils';

const savedKeywordsKey = 'mm-savedKeywords';

@Injectable()
export class KeywordService {

  private keywordsUrl = '/keywords';
  private projectsUrl = '/projects/';

  constructor(private http: HttpClient, private configService: ConfigService) {

  }


  private getKeywordsUrl(): string {
    return joinUrl(this.configService.getMmConfig().apiUrl, this.keywordsUrl);
  }

  private getProjectKeywordsUrl(projectId: number): string {
    return joinUrl(this.configService.getMmConfig().apiUrl, this.projectsUrl + projectId + this.keywordsUrl);
  }

  saveKeywordsToLocalStorage(keywords: Keyword[]) {
    const savedKeywords = localStorage.getItem(savedKeywordsKey);
    if (savedKeywords) {
      localStorage.removeItem(savedKeywordsKey);
    }
    localStorage.setItem(savedKeywordsKey, JSON.stringify(keywords));
  }

  getSavedKeywords(): Keyword[] {
    const savedKeywords = localStorage.getItem(savedKeywordsKey);
    return savedKeywords ? JSON.parse(savedKeywords) : null;
  }

  getKeywords(top: number = 10000,
              skip: number = 0,
              apptype: number = null,
              language: string = null,
              keyword: string = null): Observable<Keywords> {
    let httpParams: HttpParams = new HttpParams();
    if (top) {
      httpParams = httpParams.set('$top', top.toString());
    }
    if (skip) {
      httpParams = httpParams.set('$skip', skip.toString());
    }
    if (apptype) {
      httpParams = httpParams.set('apptype', apptype.toString());
    }
    if (language) {
      httpParams = httpParams.set('language', language);
    }
    if (keyword) {
      httpParams = httpParams.set('keyword', keyword);
    }
    return this.http
      .get<Keywords>(this.getKeywordsUrl(), { params: httpParams })
      .pipe(catchError(e  =>  observableThrowError(e)));
  /*    .catch(e => {
        console.error(e);
        return observableThrowError(e);
      });*/
  }

  getKeywordsByProjectId(projectId: number,
                         apptype: number = 1,
                         language: string = null,
                         keyword: string = null,
                         showsource: boolean = false): Observable<Keyword[]> {
    const endpoint = this.getProjectKeywordsUrl(projectId);
    let httpParams: HttpParams = new HttpParams();
    if (apptype) {
      httpParams = httpParams.set('apptype', apptype.toString());
    }
    if (language) {
      httpParams = httpParams.set('language', language);
    }
    if (keyword) {
      httpParams = httpParams.set('keyword', keyword);
    }
    if (showsource) {
      httpParams = httpParams.set('showsource', showsource.toString());
    }
    return this.http
      .get<Keyword[]>(endpoint, { params: httpParams })
      .pipe(catchError(e => observableThrowError(e)));
  }

}
